import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Conversion } from "../types";
import {
	getConversionDetailsAsync,
	GetConversionDetailsPayload,
	updateConversionAsync,
	UpdateConversionPayload,
	GetConversionsAsyncPayload,
	getConversionsAsync,
	setConversions,
	setConversion,
} from "./conversion.slice";

// Get list
function* getConversionsSaga(
	action: PayloadAction<GetConversionsAsyncPayload>,
) {
	const { query, callback } = action.payload;
	const skip = query.skip * (query.take || 0);
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Conversion[]>>(
				"/affiliates/dashboard/transactions",
				{
					...query,
					skip,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setConversions.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetConversions() {
	yield takeLatest(getConversionsAsync, getConversionsSaga);
}

// Get conversion details
function* getConversionDetailsSaga(
	action: PayloadAction<GetConversionDetailsPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Conversion>>(
				`/affiliates/dashboard/transactions/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setConversion.type, payload: response });
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchConversionDetails() {
	yield takeLatest(getConversionDetailsAsync, getConversionDetailsSaga);
}

// Update part type
function* updateConversionSaga(action: PayloadAction<UpdateConversionPayload>) {
	const { data, id, callback, onError } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(
				`/affiliates/dashboard/transactions/${id}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: getConversionDetailsAsync.type, payload: { id } });
		message.success(translate("Update successful"));
	} else {
		onError && onError();
		message.error(translate(error.message));
	}
}

function* watchUpdateConversion() {
	yield takeLatest(updateConversionAsync, updateConversionSaga);
}

const conversionSaga = [
	watchGetConversions(),
	watchConversionDetails(),
	watchUpdateConversion(),
];
export default conversionSaga;
